import { useEffect, useMemo, useState } from "react";
import WithdrawStepOne from "./WithdrawStepOne";
import WithdrawStepTwo from "./WithdrawStepTwo";
import { useSelector } from "react-redux";
import WithdrawStepTwoCrypto from "./WithdrawStepTwoCrypto";
import WithdrawStepTwoBankCard from "./WithdrawStepTwoCard";
import GetParams from "../../utils/getParams";
import { useLocation, useNavigate } from "react-router";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import DetailWrapper from "../../components/detailWrapper";
import { useTranslation } from "react-i18next";
import PleaseSetUserIDCard from "./pleaseSetUserIDCard";
import useSpecPath from "../../hook/useSpecPath";
import WithdrawNotice from "./components/withdrawNotice";
import { getDepositPaymentList } from "../../api/getApi";
import FromWithdrawHint from "./components/fromWithdrawHint";

const Withdraw = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);

  const [chooseCurrency, setChooseCurrency] = useState("PHP");
  const [withdrawStep, setWithdrawStep] = useState(1);
  const [withdrawMethod, setWithdrawMethod] = useState([]);
  const [withdrawData, setWithdrawData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [washConfig, setWashConfig] = useState({
    washPoint: 0,
    betAmount: 0,
  });
  const method = GetParams("method");

  const navigate = useNavigate();

  const location = useLocation();
  const { pathname } = location;

  const getSpecPath = useSpecPath({ specPath: "withdraw" });

  useEffect(() => {
    getDepositPaymentList().then((data) => {
      setWashConfig({
        washPoint: data.wash,
        betAmount: data.betAmount,
      });
    });
  }, []);

  return (
    <>
      {memberData.isBindAccount == 0 ? (
        <>
          <PleaseSetUserIDCard
            children={<FromWithdrawHint washConfig={washConfig} />}
          />
        </>
      ) : (
        <DetailWrapper>
          <>
            {withdrawStep === 1 && (
              <>
                <WithdrawStepOne
                  setWithdrawData={setWithdrawData}
                  setWithdrawStep={setWithdrawStep}
                  setChooseCurrency={setChooseCurrency}
                  withdrawStep={withdrawStep}
                  withdrawMethod={withdrawMethod}
                  isLoading={isLoading}
                  washConfig={washConfig}
                />
                <p
                  onClick={() => {
                    navigate(`${getSpecPath}deposit`);
                  }}
                  className="text-center my-[10px] underline text-light-text cursor-pointer"
                >
                  {i18n("deposit")}
                </p>
              </>
            )}
            {withdrawStep === 2 ? (
              method === "BankCard" ? (
                <WithdrawStepTwoBankCard
                  setWithdrawStep={setWithdrawStep}
                  chooseCurrency={chooseCurrency}
                  withdrawStep={withdrawStep}
                />
              ) : (
                <WithdrawStepTwo
                  withdrawData={withdrawData}
                  setWithdrawStep={setWithdrawStep}
                  chooseCurrency={chooseCurrency}
                  withdrawStep={withdrawStep}
                />
              )
            ) : null}
          </>
        </DetailWrapper>
      )}
    </>
  );
};

export default Withdraw;
